import Invest from './Invest';

export default Invest;
